module.exports = "images/ico-youtube.svg";